/* SANTORA CLEAN GRID — Reveal on scroll */
document.addEventListener('DOMContentLoaded', () => {
  // Selecciona secciones y tarjetas para revelar
  const targets = document.querySelectorAll(
    '.shopify-section, .card-wrapper, .product-card, .multicolumn, .collection, .image-banner, .banner, section'
  );
  targets.forEach(el => el.classList.add('reveal'));

  const io = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting){
        entry.target.classList.add('is-in');
        io.unobserve(entry.target);
      }
    });
  }, { rootMargin: '0px 0px -10% 0px', threshold: 0.02 });

  targets.forEach(el => io.observe(el));
});
